import store from '@state/store'
import router from '@router'
import _ from 'lodash'
import { 
    WrongPasswordError, 
    UserNotFoundError,
    ProjectAlreadyExistsError,
    ChangingRoleForOwnerError,
    OwnerAlreadyExistsError,
    DenyDeleteOwnerError,
    NeedGoogleDocAuthError,
    UserAlreadyExistsError    
} from '@utils/errors'

const errorResponseHandler = error => {
    if (error.response.status === 401) {
        const errCode = _.get(error, 'response.data.error')
        if (errCode == 'wrongPasswordError') {
            throw new WrongPasswordError();
        } else {
            router.push('/login');
        }
    } else if (error.response.status === 409 && _.get(error, 'response.data.error') == 'userNotFound') {
        throw new UserNotFoundError();
    } else if (error.response.status === 409 && _.get(error, 'response.data.error') == 'projectAlreadyExists') {
        throw new ProjectAlreadyExistsError();
    } else if (error.response.status === 409 && _.get(error, 'response.data.error') == 'changingRoleForOwnerError') {
        throw new ChangingRoleForOwnerError();
    } else if (error.response.status === 409 && _.get(error, 'response.data.error') == 'ownerAlreadyExists') {
        throw new OwnerAlreadyExistsError();
    } else if (error.response.status === 409 && _.get(error, 'response.data.error') == 'userAlreadyExists') {
        throw new UserAlreadyExistsError();
    } else if (error.response.status === 409 && _.get(error, 'response.data.error') == 'needGoogleDocAuth') {
        const err = new NeedGoogleDocAuthError();
        err.detailedInfo = _.get(error, 'response.data.detailedInfo')
        throw err;
    } else if (error.response.status === 409 && _.get(error, 'response.data.error') == 'cannotReadGoogleDoc') {
        store.dispatch('notifications/setInfo', {
            data: {
                title: "app.Warning",
                text: "app.CannotReadGoogleDoc"
            },
        })
    } else {
        store.dispatch('notifications/setError', {
            error: error.response,
        })
    }
}

const applyBaseInterceptors = axiosInstance => {
    axiosInstance.interceptors.response.use(
        response => response,
        errorResponseHandler
    )
}

export default {
    use(axiosInstance) {
        applyBaseInterceptors(axiosInstance)
    },
}
